import { fetchRequest } from 'Utils/api-fetch-request';

const ASSIGNMENTS_BASE_URL = '/api/polls/assignments';

export interface PollInteractionSubmit {
    option_id: number;
    shown_position: number;
}

export interface PollTrackingEvent {
    viewed_uuid: string;
    event: string;
    selected_option_id?: number;
    shown_position?: number;
}

export function submitPollInteraction(assignmentId: number, body: PollInteractionSubmit) {
    return fetchRequest(`${ASSIGNMENTS_BASE_URL}/${assignmentId}/interactions/`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
}

export function dismissPoll(assignmentId: number) {
    return fetchRequest(`${ASSIGNMENTS_BASE_URL}/${assignmentId}/interactions/`, {
        method: 'POST',
        body: JSON.stringify({ dismiss: true }),
    });
}

export function trackPollEvent(assignmentId: number, body: PollTrackingEvent) {
    return fetchRequest(`${ASSIGNMENTS_BASE_URL}/${assignmentId}/tracking/`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
}
